import { openBlock as a, createBlock as i, withCtx as l, createElementVNode as o, createVNode as n } from "vue";
import { themeProp as s } from "../../composables/useTheme.js";
import { sectionProps as m } from "../../templates/sections/mixins/useSectionProps.js";
import p from "../../templates/sections/section-single/section-single.vue.js";
import u from "./quote-simple/quote-simple.vue.js";
const c = { class: "ds-grid" }, r = { class: "ds-grid__col ds-grid__col--12 ds-lg-grid__col--8" }, d = /* @__PURE__ */ Object.assign({
  name: "DsQuote"
}, {
  __name: "quote",
  props: {
    ...m,
    logo: {
      type: Object,
      default: null
    },
    text: {
      type: String,
      required: !0
    },
    author: {
      type: String,
      default: ""
    },
    extraInfo: {
      type: String,
      default: ""
    },
    appendDoubleQuotes: {
      type: Boolean,
      default: !1
    },
    link: {
      type: Object,
      default: null
    },
    animate: {
      type: Boolean,
      default: !1
    },
    ...s
  },
  setup(e) {
    return (t, h) => (a(), i(p, {
      theme: t.theme,
      "with-space": t.withSpace,
      "with-space-top": t.withSpaceTop,
      "with-space-bottom": t.withSpaceBottom,
      "full-screen": !1,
      "space-options-small": t.spaceOptionsSmall,
      "space-options-medium": t.spaceOptionsMedium,
      animate: e.animate
    }, {
      default: l(() => [
        o("div", c, [
          o("div", r, [
            n(u, {
              text: e.text,
              logo: e.logo,
              author: e.author,
              "extra-info": e.extraInfo,
              link: e.link,
              "append-double-quotes": e.appendDoubleQuotes,
              theme: t.theme,
              animate: e.animate
            }, null, 8, ["text", "logo", "author", "extra-info", "link", "append-double-quotes", "theme", "animate"])
          ])
        ])
      ]),
      _: 1
    }, 8, ["theme", "with-space", "with-space-top", "with-space-bottom", "space-options-small", "space-options-medium", "animate"]));
  }
}), y = d;
export {
  y as default
};
